import React from "react"

import { useAnalytics } from "../../../hooks/useAnalytics"
import { useCore } from "../../../hooks/useCore"

export const withHero = Component => ({ name = "Hero", analytics = {}, title, subtitle, content, link, imageVideo, position }) => {
  const {
    helpers: { isDomReady },
  } = useCore()

  const { trackPromoImpression, trackPromoClick, VisibilitySensor } = useAnalytics()

  Component.displayName = name
  return (
    <VisibilitySensor onChange={visible => visible && trackPromoImpression({ ...analytics })}>
      <Component
        title={title}
        subtitle={subtitle}
        content={content}
        link={link}
        imageVideo={imageVideo}
        position={position?.position || "first"}
        handlePromoClick={() => trackPromoClick({ ...analytics })}
        isDomReady={isDomReady}
      />
    </VisibilitySensor>
  )
}
